<template>
  <div class="messageBox" :style="messageStyle">
    <div class="msg-body">
      <i :class="[messageIcon, 'msg-icon']" :style="iconStyle"></i>
      <span class="msg-cont">{{ messageCont }}</span>
    </div>
    <div class="msg-button">
      <b-button variant="light" size="sm" class="me-3" @click="close()"> {{ $t('base.cancel') }} </b-button>
      <b-button variant="primary" size="sm" @click="sure()">{{ $t('base.confirm') }}</b-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    messageCont: {
      type: String,
      default: "",
      required: true,
    },
    messageIcon: {
      type: String,
      default: "",
    },
    iconStyle: {
      type: Object,
      default: () => {},
    },
    messageStyle: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    sure(){
      this.$emit('makeSure')
    },
    close(){
      this.$emit('makeClose')
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
.messageBox {
  display: flex;
  flex-flow: column;
  padding: 7px;
  min-width: 172px;
  min-height: 58px;
  position: absolute;
  top: -5rem;
  left: 3rem;
  background: #ffffff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.12), 0px 6px 16px rgba(0, 0, 0, 0.08),
    0px 9px 28px rgba(0, 0, 0, 0.05);
  border-radius: 2px;
  box-sizing: border-box;
  z-index: 10;
  .msg-body {
    width: 100%;
    flex: 3;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    box-sizing: border-box;
    .msg-icon {
      font-size: 14px;
      line-height: 1.5;
      margin-right: 4px;
    }
    .msg-cont {
      color: #212529;
      font-size: 14px;
    }
  }
  .msg-button {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
